import {h} from 'ui/Framework';

export default h('svg', {
  width: '57',
  height: '57',
  viewBox: '0 0 57 57',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fillRule: 'nonzero',
    fill: 'none'
  }, [
    h('path', {
      d: 'M12.597 0h31.608c1.538 0 3.032.245 4.48.757a12.59 12.59 0 0 1 5.417 3.83 12.478 12.478 0 0 1 2.742 6.1c.134.824.156 1.648.156 2.472v30.793c0 .98-.045 1.982-.245 2.94a12.599 12.599 0 0 1-3.01 5.944 12.62 12.62 0 0 1-5.572 3.585c-1.293.4-2.63.579-3.99.579-.602 0-31.675 0-32.143-.022a12.729 12.729 0 0 1-6.42-2.116 12.872 12.872 0 0 1-4.346-4.987c-.847-1.714-1.27-3.63-1.27-5.544V12.669a11.808 11.808 0 0 1 1.18-5.455 12.646 12.646 0 0 1 4.303-5.01 12.495 12.495 0 0 1 6.397-2.16C12.107 0 12.352 0 12.597 0z',
      fill: '#E4F1FD'
    }),
    h('path', {
      d: 'M47.502 46.974a8.758 8.758 0 0 0-.66-.92 9.41 9.41 0 0 0-1.891-1.75c-.88-.605-1.914-.986-2.97-1.031a5.28 5.28 0 0 0-2.198.359c-.704.247-1.386.605-2.046.964-.77.404-1.54.808-2.353 1.144-.967.404-1.979.718-3.013.943a19.208 19.208 0 0 1-3.914.314 25.975 25.975 0 0 1-6.95-1.077 26.02 26.02 0 0 1-5.651-2.49 29.151 29.151 0 0 1-4.376-3.163 32.303 32.303 0 0 1-3.123-3.163 34.55 34.55 0 0 1-1.892-2.468 10.493 10.493 0 0 1-.66-1.054L0 27.189v-14.47C0 5.698 5.564 0 12.447 0h11.106l8.225 8.524c18.56 12.877 12.557 27.077 12.557 27.077s5.278 6.057 3.167 11.373z',
      fill: '#E4F1FD'
    }),
    h('path', {
      d: 'M31.877 9c18.462 12.718 12.49 26.744 12.49 26.744s5.25 6.005 3.128 11.256c0 0-2.166-3.678-5.797-3.678-3.5 0-5.556 3.678-12.6 3.678C13.416 47 6 33.728 6 33.728c14.13 9.417 23.777 2.747 23.777 2.747-6.365-3.744-19.905-21.648-19.905-21.648 11.79 10.17 16.886 12.852 16.886 12.852-3.04-2.548-11.57-15-11.57-15 6.824 7 20.386 16.772 20.386 16.772C39.424 18.638 31.877 9 31.877 9z',
      fill: '#F7F9FA'
    })
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/swift.es6.js